<template>
  <div class="all_part">
    <!--    <div class="head">-->
    <!--      <div class="Logo">-->
    <!--        <img src="../assets/Main_menu_img/main_menu_title_Logo.png" alt=""/>-->
    <!--      </div>-->
    <!--    </div>-->
    <div>
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="all_title_span_all">
      <span>{{ tableData2.quadrant }}</span>
    </div>
    <div class="info_span_chack" v-if="PanDuanXiuGai==1">
      <div class="all_span">
        <div class="part_span" v-if="tableData2.quadrant_id==1">
          <div class="info_span">
            <span>竞争对手：</span>
            <span>{{ tableData2.enterprise }}</span>
          </div>
          <div class="info_span">
            <span>竞争人员：</span>
            <span>{{ tableData2.enterprise_name }}</span>
          </div>

        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==3||tableData2.quadrant_id ==1">
          <div class="info_span">
            <span>FAB用户：</span>
            <span>{{ tableData2.enterprise_end }}</span>
          </div>
          <div class="info_span">
            <span>FAB关联人员:</span>
            <span>{{ tableData2.enterprise_end_name }}</span>
          </div>

        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==5||tableData2.quadrant_id ==3">
          <div class="info_span">
            <span>OEM厂商:</span>
            <span>{{ tableData2.equipment_supplier }}</span>
          </div>
          <div class="info_span">
            <span>OEM用户:</span>
            <span>{{ tableData2.related_personnel_supplier_name }}</span>
          </div>

        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==5">
          <div class="info_span">
            <span>竞争对手：</span>
            <span>{{ tableData2.enterprise }}</span>
          </div>
          <div class="info_span">
            <span>竞争人员：</span>
            <span>{{ tableData2.enterprise_name }}</span>
          </div>

        </div>
      </div>
      <div class="all_span">
        <div class="part_span">
          <div class="info_span" v-if="tableData2.quadrant_id!=1">
            <span>设备型号：</span>
            <span>{{ tableData2.device_type }}</span>
          </div>
          <div class="info_span">
            <span>制程工艺：</span>
            <span>{{ tableData2.process_technology }}</span>
          </div>
          <div class="info_span" v-if="tableData2.quadrant_id!=5">
            <span>竞品类别：</span>
            <span>{{ tableData2.category }}</span>
          </div>

        </div>
        <div class="part_span">

          <!--        <div class="info_span">-->
          <!--          <span>提交人员:</span>-->
          <!--          <span>{{ tableData2.name }}</span>-->
          <!--        </div>-->
          <!--        <div class="info_span">-->
          <!--          <span>联系方式:</span>-->
          <!--          <span>{{ tableData2.phone }}</span>-->
          <!--        </div>-->
          <div class="info_span">
            <span>人员关系与活动:</span>
            <span>{{ tableData2.personnel_relations }}</span>
          </div>
          <div class="info_span">
            <span>竞品情况：</span>
            <span>{{ tableData2.equipment_condition }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="Update_input" v-if="PanDuanXiuGai==0">
      <div class="all_span">
        <div class="part_span" v-if="tableData2.quadrant_id==1">
          <div class="Update_input_title">
            <span>竞争对手：</span>
            <el-select v-model="companyChoice" filterable :placeholder="tableData2.enterprise" style="width: 290px"
                       value-key="id"
                       clearable @change="change('a', companyChoice)">
              <el-option
                  v-for="item in companyTable"
                  :key="item.id"
                  :label="item.enterprise"
                  :value="{id:item.id, companyName:item.enterprise}"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>竞争人员：</span>
            <el-select v-model="staff_name_select" filterable style="width: 290px">
              <el-option
                  v-for="item in companyStaffTable"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>

          </div>
          <div class="Update_input_title">
            <span>关联类型</span>
            <div>
              <el-radio-group v-model="selectC">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          style="    margin-right: 7px;"
                          :disabled="opt.id!=pan_input">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==3||tableData2.quadrant_id ==1">
          <div class="Update_input_title">
            <span>FAB用户：</span>
            <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 290px"
                       value-key="id"
                       clearable @change="change('b', FABcompanChoice)">
              <el-option
                  v-for="item in FABcompanyTable"
                  :key="item.id"
                  :label="item.enterprise"
                  :value="{id:item.id, companyName:item.enterprise}"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>FAB关联人员:</span>
            <el-select v-model="FABstaff_name_select" filterable placeholder="请选择" style="width: 290px">
              <el-option
                  v-for="item in FABcompanyStaffTable"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>FAB关联类型:</span>
            <el-radio-group v-model="selectFAB">
              <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)" style="margin-right: 7px"
                        :disabled="opt.id!=pan_input">
                {{ opt.value }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==5||tableData2.quadrant_id ==3">
          <div class="Update_input_title">
            <span>OEM厂商:</span>
            <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 290px"
                       value-key="id"
                       clearable @change="change('c', OEMcompanyChoice)">
              <el-option
                  v-for="item in OEMcompanyTable"
                  :key="item.id"
                  :label="item.enterprise"
                  :value="{id:item.id, companyName:item.enterprise}"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>OEM用户:</span>
            <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择" style="width: 290px">
              <el-option
                  v-for="item in OEMcompanyStaffTable"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>OEM关联类型:</span>
            <el-radio-group v-model="selectOEMs">
              <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)" style="margin-right: 7px"
                        :disabled="opt.id!=pan_input">
                {{ opt.value }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==5">
          <div class="Update_input_title">
            <span>竞争对手：</span>
            <el-select v-model="companyChoice" filterable :placeholder="tableData2.enterprise" style="width: 290px"
                       value-key="id"
                       clearable @change="change('a', companyChoice)">
              <el-option
                  v-for="item in companyTable"
                  :key="item.id"
                  :label="item.enterprise"
                  :value="{id:item.id, companyName:item.enterprise}"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>竞争人员：</span>
            <el-select v-model="staff_name_select" filterable style="width: 290px">
              <el-option

                  v-for="item in companyStaffTable"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>

          </div>
          <div class="Update_input_title">
            <span>关联类型</span>
            <div>
              <el-radio-group v-model="selectC">
                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"
                          style="    margin-right: 7px;"
                          :disabled="opt.id!=pan_input">
                  {{ opt.value }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="all_span">
        <div class="part_spans">
          <div class="Update_input_title" v-if="tableData2.quadrant_id!=1">
            <span>设备型号：</span>
            <el-select v-model="deviceChoice" filterable placeholder="请选择" style="width: 290px" clearable
                       @change="change('d', companyChoice)">
              <el-option
                  v-for="item in deviceTable"
                  :key="item.value"
                  :label="item.device_type"
                  :value="item.device_type">
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>制程工艺：</span>
            <el-select v-model="processChoice" filterable placeholder="请选择" style="width: 290px">
              <el-option
                  v-for="item in processTable"
                  :key="item.value"
                  :label="item.process_technology"
                  :value="item.process_technology">
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title" v-if="tableData2.quadrant_id!=5">
            <span>竞品类别：</span>
            <el-select v-model="categoryChoice" filterable placeholder="请选择" style="width: 290px">
              <el-option
                  v-for="item in categoryTable"
                  :key="item.value"
                  :label="item.title"
                  :value="item.title">
              </el-option>
            </el-select>
          </div>

        </div>
        <div class="part_spans">
          <div class="Update_input_title">
            <span>竞品情况：</span>
            <el-input
                style="width: 290px"
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                v-model="JingPingDevice">
            </el-input>

          </div>
          <!--          <div class="Update_input_title">-->
          <!--            <span>提交人员:</span>-->
          <!--            <el-input style="width: 290px" v-model="TijiaoUser"></el-input>-->
          <!--          </div>-->
          <!--          <div class="Update_input_title">-->
          <!--            <span>联系方式:</span>-->
          <!--            <el-input style="width: 290px" v-model="phone"></el-input>-->
          <!--          </div>-->
          <div class="Update_input_title">
            <span>人员关系与活动:</span>
            <el-input
                style="width: 290px"
                type="textarea"
                :rows="5"
                placeholder="请输入内容"
                v-model="RenYuanGuanXI">
            </el-input>

          </div>
        </div>
      </div>
    </div>
    <div v-if="PanDuanXiuGai==0">
      <el-button v-if="tableData2.user_id == user.id" @click="updateAll()">提交</el-button>
      <el-button @click="Pan_update()">返回</el-button>
      <el-button @click="Back_update()">返回首页</el-button>
    </div>
    <div v-if="PanDuanXiuGai==1">
      <el-button v-if="tableData2.user_id == user.id" @click="Pan_update()">修改</el-button>
<!--      <el-button @click="back_last()">返回</el-button>-->
      <el-button @click="Back_update()">返回首页</el-button>
    </div>

    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>

<script>
import {httpUrl} from "@/components/publics";
import titleBlock_computer from "@/views/titleBlock_computer";

export default {
  name: "Main_menuComputer",
  data() {
    return {
      JingPingDevice: "",
      RenYuanGuanXI: "",
      TijiaoUser: "",
      phone: "",
      PanDuanXiuGai: 1,
      info_id: "",
      pan_Show: false,
      pan_input: "",
      pan_input2: "",
      jinxuan2: 1,
      jinxuan3: 3,
      jinxuan4: 5,
      selectFAB: "",
      add_companyTable: 0,
      add_staff_type: 0,
      add_company_name: "",
      add_company_abbreviation: "",
      companyStaffTable: {},
      companyStaffChoice: "",
      jinxuan: "",//判断是否禁选和传过来的UserID进行比较
      selectC: "",//单选框值
      companyTable: {},//公司列表
      FABcompanyTable: {},//FAB公司列表
      companyChoice: {},//公司列表
      OEMcompanyTable: {},//OEM公司列表
      OEMcompanyChoice: {},//公司列表
      FABcompanChoice: {},//FAB公司选择
      selectTable: {},//单选框列表
      deviceTable: {},//设备列表
      deviceChoice: "",//设备选择
      processTable: {},//制程工艺列表
      processChoice: "",//制程工艺列表
      categoryTable: {},//制程工艺列表
      categoryChoice: "",//制程工艺列表
      staff_Name: "",
      staff_phone: "",
      staff_wechart: "",
      staff_companyChoice: "",

      staff_name_select: "",
      FABstaff_name_select: "",
      OEMstaff_name_select: "",

      FABcompanyStaffTable: {},//FAB员工列表
      OEMcompanyStaffTable: {},//OEM员工列表

      add_device_type: 0,
      add_process: 0,
      add_category: 0,
      add_device: "",
      add_process_input: "",
      add_category_input: "",
      selectOEM: "",
      selectOEMs: "",
      urlImage: '',
      fileList: [],
      tableTable: [],
      user_leave: {},
      tableData: [],
      tableData2: [],
      key: "",
      user:{},
    };
  },
  components: {
    titleBlock_computer,
  },
  mounted() {
    console.log(this.$route.params.data, '这里看的是params')
    if (this.$route.params.data != '') {
      this.infoAll(this.$route.params.data)
    }
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.selectcompany();
    this.selectFABcompany();
    this.selectOEMcompany();
    this.getUser();
    this.selectName();


    this.getUser();

  },
  watch: {
    companyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectcompanystaff(newName.id);
    },
    FABcompanChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectFABcompanystaff(newName.id);
    },
    OEMcompanyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectOEMcompanystaff(newName.id);
    },

  },
  methods: {
    Pan_update() {
      this.PanDuanXiuGai = !this.PanDuanXiuGai
    },
    Back_update() {
      this.$router.push("/CompetitionRegistration");
    },
    back_last() {
      console.log(123)
      this.$router.go(-1)
    },
    change(params, val) {
      console.log(params, '这里测试的是parames');
      if (params == "a" && val != "") {
        this.staff_name_select = "";
      }
      if (params == "b" && val != "") {
        this.FABstaff_name_select = "";
      }
      if (params == "c" && val != "") {
        this.OEMstaff_name_select = "";
      }
    },
    updateAll() {
      console.log(this.companyChoice)
      this.axios
          .post(
              httpUrl + "/api/competitive_product/competitiveProductEdit",
              this.$qs.stringify({
                id: this.tableData2.id,
                quadrant_id: this.tableData2.quadrant_id,
                enterprise_id: this.companyChoice.id,
                enterprise_user_id: this.staff_name_select,
                enterprise_type: this.selectC,
                enterprise_end_id: this.FABcompanChoice.id,
                enterprise_end_user_id: this.FABstaff_name_select,
                enterprise_end_type: this.selectFAB,
                equipment_supplier_id: this.OEMcompanyChoice.id,
                equipment_supplier_user_id: this.OEMstaff_name_select,
                equipment_supplier_type: this.selectOEMs,
                device_type: this.deviceChoice,
                process_technology: this.processChoice,
                category: this.categoryChoice,
                equipment_condition: this.JingPingDevice,
                personnel_relations: this.RenYuanGuanXI,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    infoAll(infoID) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductDetails?id=${infoID}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableData2 = response.data.data;
              this.companyChoice.id = response.data.data.enterprise_id
              this.companyChoice.companyName = response.data.data.enterprise
              this.selectcompanystaff(response.data.data.enterprise_id)
              this.staff_name_select = response.data.data.enterprise_user_id
              this.selectName()
              this.selectC = response.data.data.enterprise_type
              this.FABcompanChoice.id = response.data.data.enterprise_end_id
              this.FABcompanChoice.companyName = response.data.data.enterprise_end_name
              this.selectFABcompanystaff(response.data.data.enterprise_end_id);
              this.FABstaff_name_select = response.data.data.enterprise_end_user_id
              this.selectFAB = response.data.data.enterprise_end_type
              this.OEMcompanyChoice.id = response.data.data.equipment_supplier_id
              this.OEMcompanyChoice.companyName = response.data.data.equipment_supplier
              this.selectOEMcompanystaff(response.data.data.equipment_supplier_id);
              this.OEMstaff_name_select = response.data.data.equipment_supplier_user_id
              this.selectTable = response.data.data.equipment_supplier_type
              this.selectdevice();
              this.deviceChoice = response.data.data.device_type;
              this.selectprocess();
              this.processChoice = response.data.data.process_technology;
              this.selectCategory();
              this.categoryChoice = response.data.data.category;
              this.JingPingDevice = response.data.data.equipment_condition;
              this.RenYuanGuanXI = response.data.data.personnel_relations;
              this.TijiaoUser = response.data.data.name;
              this.phone = response.data.data.phone;
              console.log(this.tableData2)
              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                this.tableData2 = response.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");
            this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    selectcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel?enterprise_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyStaffTable = response.data.data;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectFABcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_end?enterprise_end_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectOEMcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_supplier?enterprise_supplier_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询公司列表
    selectcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询FAB列表
    selectFABcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise_end`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询OEM列表
    selectOEMcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/equipment_supplier`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询设备列表
    selectdevice() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/device_type`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.deviceTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺列表
    selectprocess() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/process_technology`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.processTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //竞品类别列表
    selectCategory() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/category`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.categoryTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //单选框赋值
    selectName() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/association `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.selectTable = response.data.data;
              // console.log(selectTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },

  },
};
</script>

<style>
.el-radio-group {
  width: 100%;
}
</style>
<style scoped>
.main_buttonAndInput {
  display: flex;
  flex-direction: row;
  width: 100%;

}

.all_tables {
  width: 67%;


  height: 100%;
}


.alone_span_title {
  color: #ffffff;
  font-size: 24px;
}

.alone_span_user {
  color: #ffffff;
  font-size: 20px;
}

.Competitive_span {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.CompetitiveChoice {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

.CompetitiveChoices {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 40%;
  height: 100%;
}

.button_input_all {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;

}

.CompetitiveChoice_button_alone {
  background: #42b983;
  height: 80%;
  width: 90%;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
}

.CompetitiveChoice_button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 270pt;
  height: 102pt;
  border-radius: 4px;
}

.row_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.all_part {
  background-image: url("../assets/Main_menu_img/BG.png");
  background-position: bottom left;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  min-height: 925px;
  min-width: 1920px;
}

.head {
  background-image: url("../assets/Main_menu_img/menu_title_bg.png");
  display: flex;
  justify-content: center;
}

.main_button {
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  width: 100%;
  height: 100%;


}

.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 80%;
}

.Logo {
  margin-top: 30px;
}

.input_style {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px;
}

.input_styles {
  width: 55%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input_arr {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* border: 1px #999999 dashed; */
}

.icon_sou {
  top: 16px;
  left: 40px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 32px;
  position: absolute;
}

.ShouQi {
  position: relative;
}


.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;

}

.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}

.Fanhu {
  position: relative;
}

.button {
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 200px;
  width: 200px;

  border-radius: 6px;
}

.button span {
  font-weight: 600;
  color: #ffffff;
  font-size: 20px;
  margin-top: 30px;
}

.Copyright_information {
  margin-bottom: 15px;
}

.Main_menu_button_cl {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}

.add_info {
  width: 25%;
  height: 35%;
  background: #42b983;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 6px;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.add_staff_info_titleAndInput {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  text-align: right;

}

.add_staff_info_titleAndInput span {
  width: 14%;
  text-align: left;
}

.left {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 25%;
}

.lefts {
  display: flex;
  flex-direction: column;

  width: 25%;
}

.all_control_input_buttons_textar {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  height: 70%;
}

.all_input_control {
  height: 38%;
  display: flex;
  justify-content: space-around;
}

.all_input_controls {
  height: 62%;
  display: flex;
  justify-content: space-around;
}

.all_control_input_button {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.sousuoButton {
  position: relative;
}

.all_control_input_buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.Type_title {
  text-align: left;
}

.type_selection {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_control {

  display: flex;
  justify-content: center;
  width: 50%;
  height: 90%;
}

.title_input_buttons .titles {
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
}

.title_input_buttons {

  margin-bottom: 10px;
}

.all_controls {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 90%;
}

.title_input_button {
  align-items: center;
  display: flex;
  flex-direction: row;
  /*width: 50%;*/
  justify-content: space-between;
}

.input_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  /*justify-content: space-between;*/
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;
}

.all_input {
  display: flex;
  flex-direction: column;
}

.alone_span_title {
  color: #ffffff;
  font-size: 24px;
}

.alone_span_user {
  color: #ffffff;
  font-size: 20px;
}

.Competitive_span {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}


.CompetitiveChoice_button_alone {
  background: #42b983;
  height: 80%;
  width: 90%;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
}

.CompetitiveChoice_button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 270pt;
  height: 102pt;
  border-radius: 4px;
}

.row_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.all_part {
  background-image: url("../assets/Main_menu_img/BG.png");
  background-position: bottom left;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  min-height: 925px;
  min-width: 1920px;
}

.head {
  background-image: url("../assets/Main_menu_img/menu_title_bg.png");
  display: flex;
  justify-content: center;
}

.main_button {
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  width: 100%;
  height: 100%;
}

.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 80%;
}

.Logo {
  margin-top: 30px;
}

.button_update {
  height: 150px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.button {
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 200px;
  width: 200px;
  background-color: #18a575;
  border-radius: 6px;
}

.button span {
  font-weight: 600;
  color: #ffffff;
  font-size: 20px;
  margin-top: 30px;
}

.Copyright_information {
  margin-bottom: 15px;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
}

.tavless {
  height: 50%;
}

.tables_input_mainMenu_button {
  display: flex;
  flex-direction: row;
}

.button_table_all {
  display: flex;
  flex-direction: row;
}

.test {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  width: 100%;
  height: 100%;
}

.Update_input {
  display: flex;
  flex-direction: row;
  height: 60%;
  width: 100%;
  justify-content: space-around;
}

.Update_input_title {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.Update_input_title span {
  display: flex;
  flex-direction: row;
  width: 30%;
}

.all_span {
  width: 30%;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;

}

.info_span {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

}

.info_span_chack {
  height: 50%;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;

}

.part_span {
  display: flex;
  flex-direction: column;
  height: 40%;
  justify-content: space-between;
  border: 2px #E7E7E7 dashed;
  padding: 10px;
}

.part_spans {
  display: flex;
  flex-direction: column;
  height: 40%;
  justify-content: space-between;
  border: 2px #E7E7E7 dashed;
  padding: 10px;
}

.all_title_span_all {
  align-items: center;
  justify-content: center;
  font-size: 26px;
  width: 30%;
  display: flex;
  flex-direction: row;
  margin-left: 30px;
}
</style>
